<template>
  <div class="d-flex fd-column">
    <div v-if="showDropDown" class=" m-x-0:mo">
      <vk-listbox
          ref="listbox"
          class="FILTER"
          menuClass="MENU"
          v-model="selected"
          :display-text="sectionTitle"
          @input="onFilterInput"
          @click.prevent="$emit('click')"
      >
        <vk-listbox-option
            v-for="value in categoriesList"
            class="OPTION"
            :key="value"
            :value="value"
        >
          {{ value }}
        </vk-listbox-option>
      </vk-listbox>
    </div>
    <div v-else>
      <div class="TITLE p-b-2:t">{{ sectionTitle }}</div>
      <div class="d-flex fd-column:t jc-between:mo p-b-2 p-b-1:mo">

        <div
            v-for="(category, index) in categoriesList"
            :key="index"
            class="p-1"
            @click.prevent="$emit('selection',category, sectionTitle)">
          <router-link
              :to="{
                name: 'dashboard::pro::education',
                query: displayAll ? {
                  progress: category,
                }:{
                  category: category,
                },
              }"
              class="OPTION text-capitalize"
          >
            <span class="OPTION" v-if="displayAll">{{ categoryAndCount(category) }}</span>
            <span class="OPTION" v-else>{{ category }}</span>
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'education-nav-list',
  props: {
    categories: {
      type: Object,
      default: () => ({}),
    },
    displayAll: {
      type: Boolean,
      default: false,
    },
    sectionTitle: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      selected: '',
    };
  },
  computed: {
    showDropDown () {
      return !this.displayAll && !this.$device.isNeitherMobileOrTablet;
    },
    categoriesList () {
      return Object.keys(this.categories).sort();
    },
  },
  watch: {
    $route: {
      handler (newval) {
        if (!Object.keys(this.categories).includes(newval.query.category)) {
          this.selected = '';
        }
      },
    },
  },
  methods: {
    onFilterInput (selectedValue) {
      this.$emit('selection');

      this.$nextTick(() => {
        this.$router.push({
          name: 'dashboard::pro::education',
          query: {
            category: selectedValue,
          },
        });
      });
    },
    categoryAndCount (category) {
      return `${category}: ${this.categories[category].length || 0}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";
  .TITLE {
    font-weight: 600;
  }
  .FILTER {
    color: $color-depot;
    font-weight: 600;

    /deep/ .input {
      width: auto;
      border: 0px solid transparent;
      padding: 0 0 0 0;
    }
    /deep/.VK-LISTBOX-TEXT{
      padding-right: 8px;
    }
  }
  /deep/ .MENU {
    border: 0px solid transparent;
    font-size: 14px;
    font-weight: 600;
    box-shadow: 0px 4px 3px -3px $color-gray60;
    height: auto;
    padding-bottom: $unit;
    background-color: white;
    width: 100vw;
    margin-left: -24px;


    .SELECTED {
      background-color: #E6F7FF;
    }
    .OPTION {
      color: #286FAD;
      padding: 0px 0px 24px 24px ;
    }
  }
  .OPTION {
      color: #286FAD;
      font-size: 14px;
      font-weight: 600;
      padding: 16px 0px;
  }
</style>
